import { LanguageCode, languageCodes, languageCodesSet } from '../language.ts';

// Query parameter for the language code
const LANGUAGE_CODE_QUERY_PARAMETER: string = 'lng';

/**
 * Check if a given language code is available in the i18n configuration.
 * @param {string} languageCode The language code to check.
 * @returns {boolean} True if the language code is available, False otherwise.
 */
export function isLanguageCodeValid(languageCode: string): boolean {
    const isValid = languageCodesSet.has(languageCode as LanguageCode);
    return isValid;
}

/**
 * Get the language code from the URL query parameters.
 * @returns {string | null} The query parameter value, otherwise null.
 */
export function getLanguageCodeFromURL(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    const languageCode = urlParams.get(LANGUAGE_CODE_QUERY_PARAMETER);
    return languageCode;
}

/**
 * Set the language code in the URL query parameters.
 * @param {LanguageCode} languageCode The language code to set.
 */
export function setLanguageCodeInURL(languageCode: LanguageCode): void {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(LANGUAGE_CODE_QUERY_PARAMETER, languageCode);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
}

/**
 * Get all available language codes.
 * @returns {readonly LanguageCode[]} Array of available language codes.
 */
export function getAvailableLanguageCodes(): readonly LanguageCode[] {
    return languageCodes;
}